import { Box, Chip } from "@mui/material";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ReusableTable from "../../common/table/CommonTable";
import { fetchTransferPatientMember } from "../../redux/TransferPatient/transferPatientAction";

const StaffTransferHistoryList = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const transferState = useSelector(
    (state) => state?.transferPatient?.fetchTransferPatient || {}
  );
  const [currentPage, setCurrentPage] = useState(1);
  const loginValues = useSelector((state) => state.values?.loginValues || []);
  const userInfo = loginValues[0]?.user || {};
  const staff_id = userInfo.staff_id;
  const totalPages = transferState?.data.totalPages || 0;

  const fetchData = async (page) => {
    await dispatch(fetchTransferPatientMember(staff_id, page));
    setLoading(false);
  };
  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage, dispatch]);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };
  const transferData = transferState?.data?.data || [];

  const formattedData = transferData.map((item, index) => ({
    serialNo: index + 1,
    patientName: item.Patient?.patient_name || "-",
    ipNumber: item.Patient?.ip_number || "-",
    phoneNumber: item.Patient?.phone || "-",
    oldBlock: item.old_Block?.block_name || "-",
    oldFloor: item.old_Floor?.floor_name || "-",
    oldWard: item.old_Ward?.ward_name || "-",
    newBlock: item.new_Block?.block_name || "-",
    newFloor: item.new_Floor?.floor_name || "-",
    newWard: item.new_Ward?.ward_name || "-",
    transferDate: new Date(item.updatedAt).toLocaleDateString(),
    reason: item.reason || "-",
  }));

  const columns = [
    { id: "serialNo", label: "S.No", sortable: true },
    { id: "patientName", label: "Patient Name", sortable: true },
    { id: "ipNumber", label: "IP Number", sortable: true },
    { id: "phoneNumber", label: "Phone Number", sortable: true },
    {
      id: "oldBlock",
      label: "Old Block",
      sortable: true,
      render: (value) => <Chip label={value} color="warning" size="small" />,
    },
    {
      id: "oldFloor",
      label: "Old Floor",
      sortable: true,
      render: (value) => <Chip label={value} color="warning" size="small" />,
    },
    {
      id: "oldWard",
      label: "Old Ward",
      sortable: true,
      render: (value) => <Chip label={value} color="warning" size="small" />,
    },
    {
      id: "newBlock",
      label: "New Block",
      sortable: true,
      render: (value) => <Chip label={value} color="success" size="small" />,
    },
    {
      id: "newFloor",
      label: "New Floor",
      sortable: true,
      render: (value) => <Chip label={value} color="success" size="small" />,
    },
    {
      id: "newWard",
      label: "New Ward",
      sortable: true,
      render: (value) => <Chip label={value} color="success" size="small" />,
    },
    { id: "transferDate", label: "Transfer Date", sortable: true },
    { id: "reason", label: "Reason", sortable: true },
  ];

  return (
    <Box>
      <ReusableTable
        title="Staff Transfer History"
        columns={columns}
        data={formattedData}
        isLoading={loading}
        headerColor="#000"
        rowColor="#ffffff"
        alternateRowColor="#f5f5f5"
        withPagination={true}
        withActions={false}
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={handlePageChange}
        showDownloadOption={true}
      />
    </Box>
  );
};

export default StaffTransferHistoryList;
